export const SET_QUESTION_SELECTED = 'SET_QUESTION_SELECTED'